<template>
  <LoadingBlock :loading="loading">
    <div class="mb-4">
      <label class="form-label">Добавить товары</label>
      <MultiSelect
          v-model="selectedProductIds"
          :options="productOptions"
          optionLabel="label"
          optionValue="id"
          filter
          placeholder="Поиск товаров"
          style="width: 100%"
          @filter="onProductFilter"
          @change="onProductsSelected"
      />
    </div>

    <div v-if="!linkedProducts.length" class="text-muted mb-3">
      Привязанные товары отсутствуют
    </div>

    <table v-else class="table">
      <tbody>
      <tr v-for="product in linkedProducts" :key="product.id">
        <td>{{ product.name || product.id }}</td>
        <td class="text-end">
          <button type="button" class="btn btn-icon btn-label-secondary waves-effect"
                  @click="unlinkProduct(product.id)">
            <span class="ti ti-trash ti-md"></span>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </LoadingBlock>
</template>

<script>
import LoadingBlock from "@/components/page/LoadingBlock.vue";
import {MultiSelect} from "primevue";
import {getProducts} from "@/api/product";
import {linkProducts, unlinkProducts} from "@/api/certificate";
import {user} from "@/data/user";
import {Message, Messages} from "@/data/messages";
import {parseCertificateError} from "@/data/certificate";

export default {
  name: "ProductLinker",
  components: {LoadingBlock, MultiSelect},
  props: {
    certificateId: {
      type: String,
      required: true,
    },
    linkedProductIds: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['changed'],
  data() {
    return {
      loading: false,
      productOptions: [],
      linkedProducts: [],
      selectedProductIds: [],
      filterTimeout: null,
    }
  },
  watch: {
    linkedProductIds: {
      immediate: true,
      handler() {
        this.loadLinkedProducts()
      },
    },
  },
  methods: {
    async loadLinkedProducts() {
      if (!this.linkedProductIds.length) {
        this.linkedProducts = []
        return
      }
      this.loading = true
      try {
        const company = user.active_company
        const result = await getProducts(company, {size: 100})
        const productsById = Object.fromEntries(
            (result.data.items || []).map((product) => [product.id, product])
        )
        this.linkedProducts = this.linkedProductIds.map((id) => ({
          id,
          name: productsById[id]?.name || id,
        }))
      } finally {
        this.loading = false
      }
    },
    onProductFilter(event) {
      clearTimeout(this.filterTimeout)
      this.filterTimeout = setTimeout(() => {
        this.searchProducts(event.value)
      }, 300)
    },
    async searchProducts(name = '') {
      const query = {size: 50}
      if (name) {
        query.name = name
      }
      const result = await getProducts(user.active_company, query)
      const linkedSet = new Set(this.linkedProductIds)
      this.productOptions = (result.data.items || [])
          .filter((product) => !linkedSet.has(product.id))
          .map((product) => ({
            id: product.id,
            label: product.name,
          }))
    },
    async onProductsSelected() {
      const newIds = this.selectedProductIds.filter((id) => !this.linkedProductIds.includes(id))
      if (!newIds.length) {
        return
      }
      this.loading = true
      const message = new Message()
      try {
        await linkProducts(this.certificateId, newIds)
        message.type = 'success'
        message.autoremove = 10
        message.text = 'Товары привязаны'
        Messages.list.push(message)
        this.selectedProductIds = []
        this.$emit('changed')
      } catch (e) {
        message.type = 'failure'
        message.text = parseCertificateError(e)
        Messages.list.push(message)
      }
      this.loading = false
    },
    async unlinkProduct(productId) {
      if (!confirm('Отвязать товар от сертификата?')) {
        return
      }
      this.loading = true
      const message = new Message()
      try {
        await unlinkProducts(this.certificateId, [productId])
        message.type = 'success'
        message.autoremove = 10
        message.text = 'Товар отвязан'
        Messages.list.push(message)
        this.$emit('changed')
      } catch (e) {
        message.type = 'failure'
        message.text = parseCertificateError(e)
        Messages.list.push(message)
      }
      this.loading = false
    },
  },
  async mounted() {
    await this.searchProducts()
  },
}
</script>
